import MargemBruta from '../MargemBruta/margemBruta';

// Versão reduzida da página de Margem Bruta para os GPs: reaproveita todo o
// carregamento e cálculo de dados, exibindo apenas Faturamento Bruto/Líquido
// (KPI), o gráfico "Faturamento Bruto por Projeto" e a tabela de
// Detalhamento Analítico por Projeto — sem nenhuma informação de margem/custo.
const FaturamentoGp = () => <MargemBruta visaoGp />;

export default FaturamentoGp;
